export default "__VITE_ASSET__Dho1HpFe__"